module.exports = __webpack_public_path__ + "img/creamy-butternut-squash-soup.0cb8c6dc.jpg";